import { render, staticRenderFns } from "./PcSideChatsBanner.vue?vue&type=template&id=021ffb03&"
import script from "./PcSideChatsBanner.vue?vue&type=script&lang=ts&"
export * from "./PcSideChatsBanner.vue?vue&type=script&lang=ts&"
import style0 from "@/chat/pc-chat-banner.css?vue&type=style&index=0&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports